<div class="statistics row row-gutters" *ngIf="stats$ | async as stats">
  <div class="col col-xs-12 col-md-3" *ngFor="let stat of stats">
    <mat-card appearance="outlined">
      <mat-card-content>
        <glxy-statistic>
          <glxy-statistic-title>{{ stat.title }}</glxy-statistic-title>
          <glxy-statistic-value *ngIf="!stat.loading">{{ stat.value }}</glxy-statistic-value>
          <glxy-statistic-value class="stencil-shimmer" *ngIf="stat.loading"></glxy-statistic-value>
        </glxy-statistic>
      </mat-card-content>
    </mat-card>
  </div>
</div>
